<template>
  <div class="box box--red">
    <h2 class="box__title">{{ $t('boxes.duration.title') }}</h2>
    <span class="fz--large">{{ visitors.averageTimeElapsed }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    visitors: 'metrics/visitors',
  }),
};
</script>



// WEBPACK FOOTER //
// src/screens/Metrics/components/boxes/AverageTime.vue